import "./styles.moduleRenamed.css";

export const inspector = "styles-module__inspector___Ty-AW";
export const bottom = "styles-module__bottom___vmQOK";
export const mini = "styles-module__mini___-S7bn";
export const line = "styles-module__line___gvS1U";
export const h = "styles-module__h___vWqKR";
export const v = "styles-module__v___fhmaR";
export const dashed = "styles-module__dashed___4Doin";
export const length = "styles-module__length___Kr3A-";

export default {
  inspector: "styles-module__inspector___Ty-AW",
  bottom: "styles-module__bottom___vmQOK",
  mini: "styles-module__mini___-S7bn",
  line: "styles-module__line___gvS1U",
  h: "styles-module__h___vWqKR",
  v: "styles-module__v___fhmaR",
  dashed: "styles-module__dashed___4Doin",
  length: "styles-module__length___Kr3A-",
};